import { initAssessmentFormSubmit, initDoneStageForm, handleClosePopupDone } from './handler';

export function initDoneStage() {
	initDoneStageForm();
	initAssessmentFormSubmit();
	handleClosePopupDone();
}
